import { render } from "./TheScooterTypeGenerals.vue?vue&type=template&id=8f67535a"
import script from "./TheScooterTypeGenerals.vue?vue&type=script&lang=js"
export * from "./TheScooterTypeGenerals.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__